<script lang="ts">
    
    import { fade } from "svelte/transition";

</script>

<div class="error-screen" transition:fade={{ duration: 300 }}>
    <svg class="background no-interactive" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443.953 788.995">
        <g transform="translate(10.547 23.958)">
            <path d="M4762.427-23.958,4660.453,118.036,4789.406-23.958Z" transform="translate(-4356)" fill="#f1f1f1" opacity="0.244"/>
            <path d="M4762.427,118.036,4660.453-23.958l128.953,141.995Z" transform="translate(-4356 647)" fill="#f1f1f1" opacity="0.244"/>
            <path d="M4687.432-23.958l101.974,141.995L4660.453-23.958Z" transform="translate(-4671)" fill="#f1f1f1" opacity="0.244"/>
            <path d="M4687.432,118.036,4789.406-23.958,4660.453,118.036Z" transform="translate(-4671 647)" fill="#f1f1f1" opacity="0.244"/>
        </g>
    </svg>
      
    <div class="content">
        <slot />
    </div>
</div>

<style lang="scss">

    .error-screen {
        position: fixed;
        z-index: 200;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        touch-action: auto;
        pointer-events: auto;
        background-color: var(--too-far-background-color);
        color: #fff;
    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .content {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

</style>
